/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable no-restricted-globals */
import React, { useState } from 'react';
import { Stack } from '@mui/material';
import { IAlertProps } from '../../interface/IAlertProps';
import { getDefaultAlertProps } from '../../utils/utils';
import { MyAlert } from '../UI/MyAlert';
import { WINDOW_V } from '../../constant/constants';

export const SignInEmptyDiv = () => {
  const [windowState, setWindowState] = useState(WINDOW_V);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );

  return (
    <Stack
      height="100%"
      alignItems="center"
      justifyContent="center"
      spacing={1}
    >
      <MyAlert
        message={alertProps.message}
        severity={alertProps.severity}
        onClose={() => setAlertProps({ ...alertProps, message: '' })}
      />
    </Stack>
  );
};
